import { BREAKPOINTS, BREAKPOINT, type BreakpointType } from "./constants";

export function getBreakpoint(width: number): BreakpointType {
    if (width <= BREAKPOINTS.S) {
        return BREAKPOINT.S;
    }
    if (width <= BREAKPOINTS.L) {
        return BREAKPOINT.L;
    }
    return BREAKPOINT.XL;
}

export function isBreakpoint(
    width: number,
    breakpoint: BreakpointType,
): boolean {
    return getBreakpoint(width) === breakpoint;
}
